import React from "react";
import { graphql } from "gatsby";
import Banner from "./banner";

const BannerList = ({ bannerListData }) => {
  return bannerListData.bannerList.length > 0
    ? bannerListData.bannerList.map((banner, index) => {
        return <Banner bannerData={banner} key={`banner-` + index} />;
      })
    : "";
};

export default BannerList;

export const query = graphql`
  fragment BannerList on ContentfulBannerList {
    bannerList {
      ...Banner
    }
  }
`;
